<template>
<div class="dboard-card">
  <loading-progress
    v-if="isLoading"
    :progress="60"
    :indeterminate=true
    :hide-background="true"
    size="64"
    rotate
    fillDuration="2"
    rotationDuration="1"
  />
  <div class="row" v-else>
    <div class="col-lg-12">
      <div class="dboard-card-title">
        Capacity Utilization
      </div>
      <div class="dboard-card-panel">
        <div class="dboard-card-panel-section">
          <div class="bar">
            <div class="bar-section">
              <div class="bar-section-title">Truck Type</div>
              <div class="bar-section-dropdown">
                <FilterDropdown :options="vehicletype"
                :selected="selectedVehicle"
                @updateOption="vehicleSelected"/>
              </div>
            </div>
            <loading-progress
              v-if="isUtilizedLoading"
              :progress="60"
              :indeterminate=true
              :hide-background="true"
              size="64"
              rotate
              fillDuration="2"
              rotationDuration="1"
            />
            <div v-else>
              <div class="clearfix"></div>
              <div class="bar-title">Weight</div>
              <!-- <svgicon name="WeightChart" width="400" height="70" :original="true" /> -->
              <div class="bar-container">
                <div class="weight-bar" :style="weightStyle">
                </div>
                <span class="percentage-text">
                  {{Number(this.weightPercentage).toFixed(2)}}%
                </span>
              </div>
              <div class="total-qty">{{weight_kg}} kg</div>
              <div class="bar-title">Volume</div>
              <!-- <svgicon name="VolChart" width="400" height="70" :original="true" /> -->
              <div class="bar-container">
                <div class="volume-bar" :style="volumeStyle">
                </div>
                <span class="percentage-text percentage-text-volume">
                  {{Number(this.volumePercentage).toFixed(2)}}%
                </span>
              </div>
              <div class="total-qty">{{volume_cft}} CFT</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="dboard-card-title">
        Top 3 Truck Types Requested
      </div>
      <ol class="dboard-card-panel-list ">
        <li class="dboard-card-panel-section" v-for="item in top3" :key="item.id">
          <div class="dboard-card-section-sectitle primary-text dsplinline">
            {{item.name}}
          </div>
          <div class="dboard-card-section-tertiarynumber primary-text dsplinline-right">
            {{item.count}}
          </div>
        </li>
      </ol>
    </div>
  </div>
</div>
</template>
<script>
/* eslint-disable */
import FilterDropdown from '@common/components/FilterDropdown';

export default {
  components: {
    FilterDropdown,
  },
  props: {
    isLoading: {
      type: Boolean,
    },
    vehicletype: {
      type: Array,
    },
    selectedMonth: {
      type: Object,
    },
    selectedYear: {
      type: Object,
    },
    selectedDepot: {
      type: Object
    },
    day: {
      type: Object,
    },
    selectedTransporter: {
      type: Object,
    },
    multiSelectedDepotIds: {
      type: String,
    },
  },
  data() {
    return {
      isUtilizedLoading: false,
      volume_cft: 0,
      weight_kg: 0,
      weight_utilized: 0,
      volume_utilized: 0,
    }
  },
  computed: {
    weightStyle() {
      return `width: ${this.weightPercentage}%`;
    },
    volumeStyle() {
      return `width: ${this.volumePercentage}%`;
    },
    top3() {
      return this.vehicletype.sort((a, b) => a.percentage < b.percentage).slice(0, 3);;
    },
    selectedVehicle() {
      this.vehicle = this.vehicletype[0];
      if(!this.isfetchfirst) {
        this.fetch();
        this.isfetchfirst = true;
      }
      return this.vehicle;
    },
    weightPercentage() {
      return (this.weight_utilized / this.weight_kg) * 100;
    },
    volumePercentage() {
      return (this.volume_utilized / this.volume_cft) * 100;
    }
  },
  methods: {
    vehicleSelected(vehicle) {
      this.vehicle = vehicle;
      this.fetch();
    },
    assignResult(result) {
      if (result) {
        this.volume_cft = result.volume;
        this.weight_kg = result.weight;
        this.weight_utilized = result.weight_utilized;
        this.volume_utilized = result.volume_utilized;
      }
    },
    async fetch() {
      if (!this.isUtilizedLoading) {
        this.isUtilizedLoading = true;
        const depotId = this.multiSelectedDepotIds || this.selectedDepot.id;
        let param = {
          year: this.selectedYear.name,
          depot_id: depotId,
          vehicle_type_id: this.vehicle.id };
        param = this.prepareResponse(param);
        const result = await this.$store.dispatch('dashboard/vehicletypeutilized', param);
        // progress feedback time
        await (new Promise(resolve => setTimeout(resolve, 1000)));
        this.assignResult(result);
        this.isUtilizedLoading = false;
        this.utilizeddata = result;
      }
    },
    prepareResponse(obj) {
      if (this.day && this.day.id !== 0) {
        let date = new Date();
        date.setYear(this.selectedYear.name);
        date.setMonth(this.selectedMonth.id - 1);
        date.setDate(this.day.name);
        obj.date = date.toISOString();
        delete obj.year;
      } else {
        obj.month = this.selectedMonth.name.toLowerCase();
      }
      if (this.selectedTransporter && this.selectedTransporter.id !== 0) {
        obj.transporter_id = this.selectedTransporter.id;
      }
      return obj;
    },
  },
  watch: {
    selectedMonth() {
      this.fetch();
    },
    day() {
      this.fetch();
    },
    selectedDepot() {
      this.fetch();
    },
    selectedTransporter() {
      this.fetch();
    },
    selectedYear() {
      this.fetch();
    },
    multiSelectedDepotIds() {
      this.fetch();
    }
  }
};
</script>
<style lang="scss">
.bar-container {
  width: 400px;
  height: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #4D5D76;
}

.weight-bar {
  // width: 50%;
  display: inline-block;
  height: 100%;
  background: linear-gradient(90deg, rgba(73,202,255,0.52) 0%, #FFFFFF 100%);
  transition: width 2s;
}
.volume-bar {
  display: inline-block;
  height: 100%;
  background: linear-gradient(90deg, rgba(255,255,255,0.76) 0%, #FFFFFF 100%);
  transition: width 2s;
}
.percentage-text {
  display: inline-block;
  top: 90px;
  position: absolute;
  color: #CADCFF;
  font-size: 10px;
  line-height: 12px;

  &-volume {
    top: 179px;
  }
}
.total-qty {
  color: #CADCFF;
  font-size: 10px;
  line-height: 12px;
  float: right;
}
.bar-section-dropdown {
  margin-top: -12px;
}
</style>
